var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAngled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6421 12.9383C14.6421 13.3525 14.9779 13.6883 15.3921 13.6883C15.8063 13.6883 16.1421 13.3525 16.1421 12.9383L16.1421 3.703L6.9068 3.703C6.49258 3.703 6.1568 4.03879 6.1568 4.453C6.1568 4.86722 6.49258 5.203 6.9068 5.203L13.5814 5.203L3.54804 15.2364C3.25515 15.5293 3.25515 16.0041 3.54804 16.297C3.84093 16.5899 4.31581 16.5899 4.6087 16.297L14.6421 6.26366L14.6421 12.9383Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngled);
export default __webpack_public_path__ + "static/media/arrow-angled.c4da5899ea4c5b8d4b9590e2f6a02ef9.svg";
export { ForwardRef as ReactComponent };